import actions from '../../actions/ui';
import { handleActions } from 'redux-actions';
import produce from 'immer';

const reducer = handleActions(
  {
    [actions.ui.probingPane.setWidth]: produce((state, action) => { state.width = action.payload }),
    [actions.ui.probingPane.setTab]: produce((state, action) => { state.currentTab = action.payload }),

    [actions.ui.probingPane.togglePane]: produce((state, action) => { state.visible = !state.visible }),
    [actions.ui.probingPane.show]: produce((state, action) => { state.visible = true }),
    [actions.ui.probingPane.hide]: produce((state, action) => { state.visible = false })
  },
  {
    width: 320,
    visible: true,
    currentTab: 0
  }
);

export default reducer;
